import React, { Component } from "react";
import { Button, Textarea } from "../widgets/index";
import "./CommentAdd.css";

export default class CommentAdd extends Component {
  render() {
    return (
      <div className="comment-border support-ticket-comment-add">
        <div className="comment">
          <Textarea
            placeholder="Write a reply..."
            value={this.props.comment}
            onChange={e => this.props.handleFieldOnChange(e.target.value)}
            error={this.props.errors.comment}
          />
          <div className="button-container">
            <Button
              id="support-issue-submit-comment"
              type="secondary"
              icon="times"
              onClick={this.props.cancelComment}
            >
              Cancel
            </Button>
            <Button
              id="support-issue-submit-comment"
              type="primary"
              icon="check"
              onClick={this.props.submitComment}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
